import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import LockedButtonOverlay from './LockedButtonOverlay';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { AvailableDisabledFeatures } from '../popups/PopupFeatureDisabled';
import sounds from 'src/lib/sounds';

const ui = uiConfig.buruburu.menu;

export type ShopActionType = 'coins' | 'gems' | 'energy';

type ShopActionButtonOpts<TDisabled = boolean> = TDisabled extends false
  ? {
      type: ShopActionType;
      onSelect: (selection: ShopActionType) => Promise<void>;
      isDisabled?: TDisabled;
    }
  : {
      type: AvailableDisabledFeatures;
      onSelect: (selection: ShopActionType) => Promise<void>;
      isDisabled?: TDisabled;
    };

export default class ShopActionButton extends ButtonScaleViewWithText {
  constructor(private opts: ShopActionButtonOpts) {
    super({
      ...ui.menuButton,
      icon: ui.icons[opts.type as keyof typeof ui.icons],
      localeText: () => i18n(`shopMenu.${opts.type}`),
      tracking: { feature: 'shopMenu', $subFeature: opts.type },
    });

    this.icon?.updateOpts({ scaleMethod: 'contain' });

    if (opts.isDisabled) {
      const { width, height } = this.style;
      this.addSubview(new LockedButtonOverlay({ width, height }));
    }
  }

  public onClick = async () => {
    // Show feature disabled popup
    if (this.opts.isDisabled) {
      sounds.sfx.play('ok');

      await openPopupPromise('popupFeatureDisabled', {
        feature: this.opts.type,
        origin: 'hud',
      });
    } else {
      await this.opts.onSelect(this.opts.type as ShopActionType);
    }
  };
}
